import { Link } from "react-router-dom";
import { Linkedin, ArrowUpRight, Mail, MapPin, Phone } from "lucide-react";
import { SITE } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-brand-navy text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img src={SITE.logo} alt="Arivu Finserve" className="h-12 w-12 rounded-md bg-white p-1 object-contain" />
              <span className="font-serif text-2xl font-semibold">Arivu Finserve</span>
            </div>
            <p className="text-white/60 max-w-sm leading-relaxed font-light">
              Independent financial planning built around your goals — helping families and professionals across India invest with clarity and confidence.
            </p>
            <a
              href={SITE.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin"
              className="inline-flex items-center gap-2 mt-6 text-sm text-white/80 hover:text-brand-accent transition-colors"
            >
              <Linkedin className="h-4 w-4" /> Connect with {SITE.advisor}
            </a>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.24em] text-brand-accent font-semibold mb-6">Navigate</h4>
            <ul className="space-y-3 text-white/70">
              <li><Link to="/" data-testid="footer-link-home" className="hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/services" data-testid="footer-link-services" className="hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/products" data-testid="footer-link-products" className="hover:text-white transition-colors">Products</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.24em] text-brand-accent font-semibold mb-6">Get in touch</h4>
            <ul className="space-y-4 text-white/70">
              <li className="flex items-center gap-3"><Mail className="h-4 w-4 text-brand-accent" /> <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="hover:text-white transition-colors">{SITE.email}</a></li>
              <li className="flex items-center gap-3"><Phone className="h-4 w-4 text-brand-accent" /> <a href={`tel:${SITE.phone.replace(/\s/g, "")}`} data-testid="footer-phone" className="hover:text-white transition-colors">{SITE.phone}</a></li>
              <li className="flex items-center gap-3"><MapPin className="h-4 w-4 text-brand-accent" /> {SITE.location}</li>
            </ul>
            <a
              href={SITE.calendly}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-book-btn"
              className="inline-flex items-center gap-2 mt-6 rounded-full bg-white text-brand-navy text-sm font-medium px-6 py-3 hover:bg-brand-accent hover:text-white transition-colors group"
            >
              Book a 30-min call <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </a>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-white/40 text-sm">
          <p>© {new Date().getFullYear()} Arivu Finserve. All rights reserved.</p>
          <p className="font-light">Mutual fund investments are subject to market risks.</p>
        </div>
      </div>
    </footer>
  );
}
